export const PREPARED_PRODUCT_SECTORS = ["Cocina", "Barra"];

export function normalizePreparedProductSectors(value) {
  const values = Array.isArray(value)
    ? value
    : typeof value === "string"
      ? value.split(",")
      : [];

  return PREPARED_PRODUCT_SECTORS.filter((sector) =>
    values.some((item) => String(item).trim().toLocaleLowerCase("es-AR") === sector.toLocaleLowerCase("es-AR")),
  );
}

export function formatPreparedProductSectors(value) {
  const sectors = normalizePreparedProductSectors(value);
  return sectors.length ? sectors.join(" y ") : "-";
}
